import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TopBar from './components/TopBar';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Industries from './components/Industries';
// import Testimonials from './components/Testimonials';
import Partners from './components/Partners';
import Footer from './components/Footer';
import ITServicesPage from './pages/ITServicesPage';
import DataCenterPage from './pages/DataCenterPage';
import InfrastructurePage from './pages/InfrastructurePage';
import NetworkCablingPage from './pages/NetworkCablingPage';
import TelecomPage from './pages/TelecomPage';
import TelephonyPage from './pages/TelephonyPage';
import IoTPage from './pages/IoTPage';
import SecurityPage from './pages/SecurityPage';
import AccessControlPage from './pages/AccessControlPage';
import NationalRolloutsPage from './pages/NationalRolloutsPage';
import NetworkRefreshPage from './pages/NetworkRefreshPage';
import WAPDeploymentPage from './pages/WAPDeploymentPage';
import HardwareDeploymentPage from './pages/HardwareDeploymentPage';
import SiteSurveysPage from './pages/SiteSurveysPage';
import ITSupportPage from './pages/ITSupportPage';
import ITDeploymentPage from './pages/ITDeploymentPage';
import BreakFixPage from './pages/BreakFixPage';
import PreventiveMaintenancePage from './pages/PreventiveMaintenancePage';
import PPESolutionsPage from './pages/PPESolutionsPage';
import DataCenterCommissioningPage from './pages/DataCenterCommissioningPage';
import SafetyProfessionalsPage from './pages/SafetyProfessionalsPage';
import DataCenterSecurityPage from './pages/DataCenterSecurityPage';
// import JanitorialStaffingPage from './pages/JanitorialStaffingPage';
import ContactUsPage from './pages/ContactUsPage';
import ScrollToTop from './components/ScrollToTop';
import SitemapPage from './pages/SitemapPage';
import AboutUsPage from './pages/AboutUsPage';
import './App.css';

// Home Page Component
const HomePage = () => {
  return (
    <div className="font-sans">
      <TopBar />
      <Navigation />
      <Hero />
      <Services />
      <WhyChooseUs />
      <Industries />
      {/* <Testimonials /> */}
      <Partners />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ITServicesPage />} />
        <Route path="/data-center" element={<DataCenterPage />} />
        <Route path="/services/infrastructure" element={<InfrastructurePage />} />
        <Route path="/services/network-cabling" element={<NetworkCablingPage />} />
        <Route path="/services/telecom" element={<TelecomPage />} />
        <Route path="/services/telephony" element={<TelephonyPage />} />
        <Route path="/services/iot" element={<IoTPage />} />
        <Route path="/services/security" element={<SecurityPage />} />
        <Route path="/services/access-control" element={<AccessControlPage />} />
        <Route path="/services/national-rollouts" element={<NationalRolloutsPage />} />
        <Route path="/services/network-refresh" element={<NetworkRefreshPage />} />
        <Route path="/services/wap-deployment" element={<WAPDeploymentPage />} />
        <Route path="/services/hardware-deployment" element={<HardwareDeploymentPage />} />
        <Route path="/services/site-surveys" element={<SiteSurveysPage />} />
        <Route path="/services/it-support" element={<ITSupportPage />} />
        <Route path="/services/it-deployment" element={<ITDeploymentPage />} />
        <Route path="/services/break-fix" element={<BreakFixPage />} />
        <Route path="/services/preventive-maintenance" element={<PreventiveMaintenancePage />} />
        <Route path="/services/ppe-solutions" element={<PPESolutionsPage />} />
        <Route path="/services/data-center-commissioning" element={<DataCenterCommissioningPage />} />
        <Route path="/services/safety-professionals" element={<SafetyProfessionalsPage />} />
        <Route path="/services/data-center-security" element={<DataCenterSecurityPage />} />
        {/* <Route path="/services/janitorial-staffing" element={<JanitorialStaffingPage />} /> */}
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/sitemap" element={<SitemapPage />} />
        <Route path="/about" element={<AboutUsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
